import { render, staticRenderFns } from "./BajajEMI.vue?vue&type=template&id=3dd15c2c&lang=html"
import script from "./BajajEMI.vue?vue&type=script&lang=js"
export * from "./BajajEMI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports